const roleField = document.querySelector(".role-field");
const otherField = document.querySelector(".other-role-field");
const showOtherField = () => {
  if (otherField) {
    otherField.parentElement?.classList.remove("hidden");
    otherField.classList.remove("hidden");
    otherField.required = true;
  }
};
const hideOtherField = () => {
  if (otherField) {
    otherField.classList.add("hidden");
    otherField.parentElement?.classList.add("hidden");
    otherField.required = false;
  }
};
const changeOtherField = () => {
  if (otherField) {
    if (roleField?.value && roleField?.value == "sonstiges") {
      showOtherField();
    } else {
      hideOtherField();
    }
  }
};
changeOtherField();
roleField?.addEventListener("change", (e) => {
  changeOtherField();
});
